import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[lxScrollTopOnNavigate]',
  standalone: true,
})
export class ScrollTopOnNavigateDirective implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();

  constructor(private elementRef: ElementRef, private router: Router) {}

  ngOnInit(): void {
    this.subscription.add(
      this.router.events.pipe(filter((ev) => ev instanceof NavigationEnd)).subscribe(() => {
        this.elementRef.nativeElement.scrollTo(0, 0);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
